export const GetRoleAll = async (resource) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/role`)
        .then(
            (response) => {
                result = response.body.role
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}